import { RswResponse, StateUpdateData } from '@chegg/rio-sdk-web'
import { ClientInterface } from '@chegg/rio-sdk-web/dist/types/types'
import { SiteState } from '../site/types'
import { PAGE_TYPES } from './constants'
import { EventSchemas } from './rsw/eventSchemas'

export type PageType =
  | typeof PAGE_TYPES.PAPERS
  | typeof PAGE_TYPES.PAPER_NOT_FOUND
  | typeof PAGE_TYPES.EDITOR_GRAMMAR
  | typeof PAGE_TYPES.EDITOR_PLAGIARISM
  | typeof PAGE_TYPES.TERMS_AND_CONDITIONS
  | typeof PAGE_TYPES.EC_FORM
  | typeof PAGE_TYPES.EC_SUCCESS
  | typeof PAGE_TYPES.EC_IN_PROGRESS
  | typeof PAGE_TYPES.EC_COMPLETE
  | typeof PAGE_TYPES.EC_UPGRADE
  | typeof PAGE_TYPES.EC_FORM_TOO_LONG
  | typeof PAGE_TYPES.EDITOR_GRAMMAR_DEMO
  | typeof PAGE_TYPES.EDITOR_PLAGIARISM_DEMO
  | typeof PAGE_TYPES.EC_DEMO
  | typeof PAGE_TYPES.PLANS

export const CHEGG_PRODUCT = 'chegg_writing' as const
export const EASYBIB_PRODUCT = 'easybib_plus' as const
export const BIBME_PRODUCT = 'bibme_plus' as const
export const CITATION_MACHINE_PRODUCT = 'citation_machine_plus' as const

type SubscriptionProduct =
  | typeof CHEGG_PRODUCT
  | typeof EASYBIB_PRODUCT
  | typeof BIBME_PRODUCT
  | typeof CITATION_MACHINE_PRODUCT

export const BUSINESS_UNIT = 'wt' as const

export type ProductMap = { [key in SiteState]: SubscriptionProduct }

export interface EventWithConfig {
  payload: EventSchemas
  config: EventConfig
  testOnly?: boolean
}

export interface EventConfig {
  stateUpdate?: StateUpdateData
  force?: boolean
  eventVersion: number | string
}

export type RioEventFn = (
  client: ClientInterface<EventSchemas>,
  eventSchemas: EventSchemas,
  eventConfig: EventConfig
) => Promise<RswResponse>



// WEBPACK FOOTER //
// ./src/state/analytics/types.ts